<template>
  <router-view />
</template>

<script>
export default {
  name: 'FastTrackIndex'
}
</script>
